import { api } from './api';

// Верификация основана на полях User: isVerify, verifyImage.
// Предполагаем наличие отдельных эндпоинтов, которые вы реализуете на бэкенде.

export const verificationService = {
  getPending: async () => {
    const { data } = await api.get('/admin/verification/pending');
    return data;
  },

  getApproved: async () => {
    const { data } = await api.get('/admin/verification/approved');
    return data;
  },

  getRejected: async () => {
    const { data } = await api.get('/admin/verification/rejected');
    return data;
  },

  approve: async (requestId) => {
    const { data } = await api.post(`/admin/verification/${requestId}/approve`);
    return data;
  },

  reject: async (requestId, reason) => {
    const { data } = await api.post(`/admin/verification/${requestId}/reject`, {
      reason,
    });
    return data;
  },
};

